require('./bootstrap');
//--
import moment from 'moment';
import Vue from 'vue';
import Vuex from 'vuex';
import vuetify from './plugins/vuetify';

//-- Resource-query init --//
import ResourceQuery from "../../vendor/plokko/resource-query/js/ResourceQuery";
// Make it available in pages
window.ResourceQuery = ResourceQuery;

//Moment init
window.moment = moment;
moment.locale(document.documentElement.lang);

window.Vue = Vue;
window.Vuex = Vuex;
window.vuetify = vuetify;

//-- Javascript translations --//
import Localization from '../../vendor/plokko/locale-manager/assets/js/Localization';

window.Localization = new Localization();

// Compatibility
window.trans = function(key,replace){return window.Localization.trans(key,replace);};
window.trans_choice = function(key,number,replace){return window.Localization.trans_choice(key,number,replace);};

// Helpers

window.formatFileSize = function (s,unit,decimals){
    let units = ['byte','kb','mb','gb','tb'];
    unit = (unit||'mb').toLowerCase();
    let bytes = s*Math.pow(1024,units.indexOf(unit));
    if(!s) return '-';
    for(let i=units.length;i>=0;i--){
        let size = bytes / Math.pow(1024,i);

        if(Math.abs(size)>=1){
            return _.round(size,decimals||2)+ ' '+ _.capitalize(units[i]);
        }
    }
};

// Vue trans mixin
Vue.mixin({
    methods:{
        trans: window.trans ,
        trans_choice: window.trans_choice ,
    },
    filters:{
        trans:(s) => window.trans(s),
        date(s){ return s?moment(s).format('L'):'-'},
        time(s){ return s?moment(s).format('HH:mm'):'-'},
        dateTime(s){ return s?moment(s).format('L HH:mm'):'-'},
        dateTimeISO(s){ return s?moment(s,moment.ISO_8601).format('L HH:mm'):'-'},
        fileSize(s){return formatFileSize(s,'byte',2)},
        fileSizeMb(s){return formatFileSize(s,'mb',2)},
    }
});

//--- Vuex store ---//
let store = new Vuex.Store( require('./VuexStore') );
window.store = store;
Vue.mixin({store});//Make store available in all vue instances


//--- Vue components ---//
Vue.component('error-badge', require('./components/ErrorBadge').default);//Laravel error
Vue.component('app-layout', require('./components/AppLayout').default);
Vue.component('auth-layout', require('./components/layout/AuthLayout').default);

Vue.component('item-loader', require('./components/ResourceQuery/ItemLoader').default);
Vue.component('data-table', require('./components/ResourceQuery/DataTable').default);
Vue.component('item-selector', require('./components/ResourceQuery/ItemSelector').default);
Vue.component('SelectItem', require('./components/SelectItem').default);
Vue.component('select-input', require('./components/SelectInput').default);

Vue.component('delete-item', require('./components/DeleteItemBtn').default);

Vue.component('file-uploader', require('./components/FileUploader').default);

//Vue.component('float-input', require('./components/FloatInput').default);
//Vue.component('dropdown-input', require('./components/DropdownInput').default);
